<template>
  <ConfirmationModal
    :bodyText="bodyText"
    :cancelText="cancelText"
    :continueText="continueText"
    :enableMainAction="true"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    :headerText="headerText"
    :loading="isLoading"
    :mainActionAttention="true"
    :visible="true"
  >
    <p>
      <strong>Are you sure?</strong> Turning off certificate distribution will stop
      certificates from being sent to devices and will <strong>remove existing certificates</strong>
      from devices.
      <span>
        This will also clear any trusted applications
        configured under macOS Keychain Application Access.
      </span>
    </p>
    <p>
      If your organization uses Conditional Access Policies with device conditions,
      those policies may be impacted.
      <span
        v-if="policies.length > 0"
        data-test-id="policy"
      >
        Device conditions are in use on the following policies:
      </span>
    </p>
    <ul
      id="id1"
      :class="$style.list"
      data-test-id="policyList"
    >
      <li
        v-for="policy in policies"
        :key="policy.id"
      >
        {{ policy.name }}
      </li>
      <li v-if="totalCount > policyCountLimit">
        ... and {{ totalCount - policyCountLimit }} more
      </li>
    </ul>
  </ConfirmationModal>
</template>

<script>
import { ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';

const authNPolicies = StoreModuleMap[ItemTypeConsts.authNPolicies];
const filter = {
  name: 'conditions',
  operator: 'search',
  value: 'deviceManaged|deviceEncrypted',
};

export default {
  ModalEventBus,
  name: 'DisableDeviceCertificateDistributionConfirmationModal',
  components: {
    ConfirmationModal,
  },
  props: {
    action: {
      default: () => this.$options.ModalEventBus.close(),
      type: Function,
    },
    policyCountLimit: {
      default: 10,
      type: Number,
    },
  },

  data: () => ({
    isLoading: true,
    bodyText: '',
    headerText: 'Disable Device Certificate Distribution',
    cancelText: 'cancel',
    continueText: 'disable',
  }),

  computed: {
    ...mapGetters(authNPolicies, {
      policies: 'getCollection',
      totalCount: 'getTotalCount',
    }),
  },

  mounted() {
    this.loadPolicies();
  },

  methods: {
    ...mapActions(authNPolicies, [
      'setFilter',
      'fetchCollection',
      'resetCollection',
    ]),
    handleCancel() {
      this.resetCollection();
      this.$options.ModalEventBus.close();
    },
    handleContinue() {
      try {
        this.action();
      } finally {
        this.$options.ModalEventBus.close();
        this.resetCollection();
      }
    },
    loadPolicies() {
      this.setFilter({
        filter,
        pagination: { limit: this.policyCountLimit },
      });

      this.fetchCollection().finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style module>
  .list.list {
    font-style: italic;
    list-style-type: none;
    margin-bottom: 0.4em;
    margin-top: 1.5em;
    padding-inline-start: 1.5em;
  }

  .list li:not(:last-child) {
    margin-bottom: 0.4em;
  }
</style>
